export default __webpack_public_path__ + "static/media/login.a35b2173.jpg";